import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

interface CurriculumProgressTrackerProps {
  titleClassName?: string
  topicId?: string
  totalCount: number
  completedCount: number
  className?: string
}

export default function CurriculumProgressTracker({
  titleClassName,
  topicId,
  totalCount = 0,
  completedCount = 0,
  className,
}: CurriculumProgressTrackerProps): React.ReactElement {
  const { t } = useTranslation('curriculum')
  const isTopicProgress = topicId !== undefined

  const fromImage = isTopicProgress
    ? `curriculum/hats/black-hat-${topicId}.png`
    : 'onboarding/icons/no-space-puzzle-piece.svg'
  const toImage = isTopicProgress
    ? `curriculum/certificate/mastery-certificate-${topicId}_v4.png`
    : 'onboarding/icons/updated-chest-purple.png'

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <p className={`flex text-start font-light text-xs md:text-sm ${titleClassName ? titleClassName : 'ml-4'}`}>
        {isTopicProgress ? t('dropdownTitle') : t('mustKnow')}
      </p>
      <div className="flex items-center h-9 md:h-18 w-35 sm375:w-38 md:w-62 border-white border-2 rounded-3 md:rounded-7 bg-gradient-dashboard gap-1 md:gap-2 justify-around px-3">
        <ResponsiveImage
          alt="Treasure Chest"
          className={`${isTopicProgress ? 'min-w-4 md:min-w-12' : 'min-w-4 md:min-w-8'}`}
          fit="contain"
          height={100}
          imageClassName="object-contain"
          srcKey={fromImage}
          width={isTopicProgress ? 100 : 50}
        />
        <p className="text-xs md:text-2xl text-white">
          {completedCount}/{totalCount}
        </p>
        <ResponsiveImage
          alt="Arrow"
          className="min-w-8 md:min-w-10"
          fit="contain"
          height={70}
          imageClassName="object-contain"
          srcKey="onboarding/icons/Arrow.svg"
          width={60}
        />

        <ResponsiveImage
          alt="Treasure Chest"
          className="min-w-2 md:min-w-12"
          fit="contain"
          height={100}
          imageClassName="object-contain"
          srcKey={toImage}
          width={100}
        />
      </div>
    </div>
  )
}
